import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.isCreate ? _vm.$i18n_t('Connectors.Transformer.editDialog.title') : _vm.transformerModel.name,
      "subtitle": _vm.isCreate ? _vm.$i18n_t('Connectors.Transformer.description') : `ID: ${_vm.transformerModel.id}`
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "disabled": !_vm.canSave,
            "color": _vm.color,
            "solid-icon": "",
            "prepend-icon": "fa-save",
            "data-cy": "createTransformation"
          },
          on: {
            "click": _vm.updateTransformer
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.save')) + "\n        ")]), _c('core-button', {
          attrs: {
            "color": "danger",
            "prepend-icon": "fa-times"
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push('/connectors/consumers/transformers');
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    staticClass: "mb-8"
  }, [_c(VTabs, {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-metadata",
      "data-cy": "tabMetadata"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Connectors.Transformer.tabs.metadata')) + "\n            ")]), _c(VTab, {
    attrs: {
      "href": "#tab-transformation",
      "data-cy": "tabTransformation"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Connectors.Transformer.tabs.transformation')) + "\n            ")]), _c(VTabsItems, {
    staticClass: "mt-6 mb-8",
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "tab-metadata",
    attrs: {
      "value": "tab-metadata"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.showMetaSkeleton ? _c(VSkeletonLoader, {
    staticClass: "custom-skeleton_loader_input",
    attrs: {
      "type": "button"
    }
  }) : _c(VTextField, {
    staticClass: "required",
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.bridgeName'),
      "autocomplete": "off",
      "required": "",
      "data-cy": "trafoName"
    },
    model: {
      value: _vm.transformerModel.name,
      callback: function ($$v) {
        _vm.$set(_vm.transformerModel, "name", $$v);
      },
      expression: "transformerModel.name"
    }
  }), _vm.showMetaSkeleton ? _c(VSkeletonLoader, {
    staticClass: "custom-skeleton_loader_input",
    attrs: {
      "type": "button"
    }
  }) : _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      "disabled": !_vm.isCreate,
      "required": "",
      "data-cy": "trafoAccount"
    },
    model: {
      value: _vm.selectedAccount,
      callback: function ($$v) {
        _vm.selectedAccount = $$v;
      },
      expression: "selectedAccount"
    }
  })], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.showMetaSkeleton ? _c(VSkeletonLoader, {
    staticClass: "custom-skeleton_loader_input",
    staticStyle: {
      "height": "151px"
    },
    attrs: {
      "type": "button"
    }
  }) : _c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.description'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "dense": "",
      "data-cy": "trafoDescription"
    },
    model: {
      value: _vm.transformerModel.transformer.description,
      callback: function ($$v) {
        _vm.$set(_vm.transformerModel.transformer, "description", $$v);
      },
      expression: "transformerModel.transformer.description"
    }
  })], 1)], 1)], 1), _c(VTabItem, {
    key: "tab-transformation",
    attrs: {
      "value": "tab-transformation"
    }
  }, [_c(VCard, {
    staticClass: "pa-4 mb-8",
    attrs: {
      "elevation": "3"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0 my-0 mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', {
    staticClass: "py-0 my-0"
  }, [_c('span', {
    class: `number-circled ${_vm.color}--text`
  }, [_vm._v("1")]), _vm._v("\n                        " + _vm._s(_vm.$i18n_t('Connectors.Transformer.defineInputOutput')) + "\n                      ")])]), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VCombobox, {
    staticClass: "required",
    attrs: {
      "items": _vm.inputOutputTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "label": _vm.$i18n_t('Connectors.Transformer.editDialog.outputType'),
      "menu-props": {
        offsetY: true
      },
      "hide-details": "auto",
      "data-cy": "trafoContentTypeOutput"
    },
    model: {
      value: _vm.transformerModel.transformer.contentTypes.output,
      callback: function ($$v) {
        _vm.$set(_vm.transformerModel.transformer.contentTypes, "output", $$v);
      },
      expression: "transformerModel.transformer.contentTypes.output"
    }
  })], 1)], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c(VCard, {
    staticClass: "pa-4 mb-0 grow",
    attrs: {
      "elevation": "3"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', {
    staticClass: "py-0 my-0"
  }, [_c('span', {
    class: `number-circled ${_vm.color}--text`
  }, [_vm._v("2")]), _vm._v("\n                            " + _vm._s(_vm.$i18n_t('Connectors.Transformer.writeTransformation')) + "\n                          ")])]), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VCombobox, {
    staticClass: "required",
    attrs: {
      "items": _vm.transformerTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "label": _vm.$i18n_t('Connectors.Transformer.editDialog.type'),
      "menu-props": {
        offsetY: true
      },
      "hide-details": "auto",
      "data-cy": "trafoType"
    },
    model: {
      value: _vm.transformerModel.transformer.type,
      callback: function ($$v) {
        _vm.$set(_vm.transformerModel.transformer, "type", $$v);
      },
      expression: "transformerModel.transformer.type"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_vm.transformerModel.transformer.type === 'jsonata' ? [_c('codemirror', {
    ref: "codemirror",
    class: {
      'elevation-3': true,
      'codemirror-transformer': true,
      'is-wide': _vm.isWide,
      'is-js': false
    },
    attrs: {
      "options": _vm.cmOptions,
      "data-cy": "trafoJsonataDefinition"
    },
    on: {
      "focus": function ($event) {
        return _vm.onCmFocus('codemirror');
      }
    },
    model: {
      value: _vm.transformerModel.transformer.definition,
      callback: function ($$v) {
        _vm.$set(_vm.transformerModel.transformer, "definition", $$v);
      },
      expression: "transformerModel.transformer.definition"
    }
  })] : _vm.transformerModel.transformer.type === 'javascript' ? [_c('code', [_vm._v("module.exports = (x) => {")]), _c('codemirror', {
    ref: "codemirror",
    class: {
      'elevation-3': true,
      'codemirror-transformer': true,
      'is-wide': _vm.isWide,
      'is-js': true
    },
    attrs: {
      "options": _vm.cmOptions,
      "data-cy": "trafoJSDefinition"
    },
    on: {
      "focus": function ($event) {
        return _vm.onCmFocus('codemirror');
      }
    },
    model: {
      value: _vm.transformerModel.transformer.definition,
      callback: function ($$v) {
        _vm.$set(_vm.transformerModel.transformer, "definition", $$v);
      },
      expression: "transformerModel.transformer.definition"
    }
  }), _c('code', [_vm._v("}")])] : _vm._e()], 2)], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c(VCard, {
    staticClass: "pa-4 mb-0",
    attrs: {
      "elevation": "3"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0 ma-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', {
    staticClass: "py-0 my-0"
  }, [_c('span', {
    class: `number-circled ${_vm.color}--text`
  }, [_vm._v("3")]), _vm._v("\n                            " + _vm._s(_vm.$i18n_t('Connectors.Transformer.testTransformation')) + "\n                          ")])]), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, [_c(VCol, {
    staticStyle: {
      "height": "80px"
    }
  }, [_c('p', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Transformer.exampleInput')))])]), _c(VCol, {
    staticStyle: {
      "height": "80px",
      "text-align": "right"
    }
  }, [_c('core-button', {
    staticClass: "ma-0",
    attrs: {
      "disabled": !_vm.canRunTransformerTest,
      "prependIcon": "fa-rocket",
      "color": _vm.color,
      "tooltip": _vm.tooltipTransformerTest,
      "data-cy": "testTransformer"
    },
    on: {
      "click": _vm.testTransformer
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$i18n_t('Connectors.Transformer.buttonTestTransformer')) + "\n                              ")])], 1)], 1), _c('codemirror', {
    ref: "testinput",
    class: {
      'elevation-3': true,
      'codemirror-test-input': true,
      'is-wide': _vm.isWide
    },
    attrs: {
      "options": _vm.cmOptions,
      "data-cy": "transformTestInput"
    },
    on: {
      "focus": function ($event) {
        return _vm.onCmFocus('testinput');
      }
    },
    model: {
      value: _vm.transformTestInput,
      callback: function ($$v) {
        _vm.transformTestInput = $$v;
      },
      expression: "transformTestInput"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$i18n_t('Connectors.Transformer.outputAfterTransformation')) + "\n                          ")]), _c('codemirror', {
    ref: "testoutput",
    class: {
      'elevation-3': true,
      'codemirror-test-output': true,
      'is-wide': _vm.isWide
    },
    attrs: {
      "options": {
        ..._vm.cmOptions,
        readOnly: true
      },
      "data-cy": "transformTestOutput"
    },
    on: {
      "focus": function ($event) {
        return _vm.onCmFocus('testoutput');
      }
    },
    model: {
      value: _vm.transformTestOutput,
      callback: function ($$v) {
        _vm.transformTestOutput = $$v;
      },
      expression: "transformTestOutput"
    }
  })], 1)], 1)], 1)], 1)], 1), _c(VRow, [_c(VCol, [_c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('span', {
    class: `number-circled ${_vm.color}--text`
  }, [_vm._v("i")]), _vm._v("\n                          " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.title')) + "\n                        ")]), _c(VExpansionPanelContent, [_c(VRow, [_c(VCol, [_c('p', {
    staticClass: "text-bold"
  }, [_vm._v("\n                                " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.transformHeadline')) + "\n                              ")]), _c('div', [_c('p', [_vm._v("\n                                  " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.transformDescription')) + "\n                                ")]), _vm._v("\n\n                                " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.availableMetaValues')) + "\n                                "), _c('ul', [_c('li', [_c('code', [_vm._v("account_id*")])]), _c('li', [_c('code', [_vm._v("config_id")])]), _c('li', [_c('code', [_vm._v("state_id")])]), _c('li', [_c('code', [_vm._v("dtwin_id")])]), _c('li', [_c('code', [_vm._v("dtwin_title")])]), _c('li', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('Connectors.Filter.metaValuePanel.twinCategory'))
    }
  })]), _c('li', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('Connectors.Filter.metaValuePanel.vdeviceGroups'))
    }
  })]), _c('li', [_c('code', [_vm._v("twin_tags")])]), _c('li', [_c('code', [_vm._v("twin_ancestor_ids")])]), _c('li', [_c('code', [_vm._v("twin_key_value")])]), _c('li', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('Connectors.Filter.metaValuePanel.geoLocation'))
    }
  })]), _c('li', [_c('code', [_vm._v("unit")])]), _c('li', [_c('code', [_vm._v("state_identifier")])]), _c('li', [_c('code', [_vm._v("state_type")])]), _c('li', [_c('code', [_vm._v("source_type")])]), _c('li', [_c('code', [_vm._v("parser_variable")])]), _c('li', [_c('code', [_vm._v("source_identifier")])]), _c('li', [_c('code', [_vm._v("timestamp*")])]), _c('li', [_c('code', [_vm._v("reference_id")])]), _c('li', [_c('code', [_vm._v("target_reference_id")])])]), _vm._v("\n                                " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.noticeMetaValues')) + "\n                              ")])])], 1), _c(VRow, [_c(VCol, [_c('p', {
    staticClass: "text-bold"
  }, [_vm._v("\n                                " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.exampleHeadline')) + "\n                              ")]), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.exampleDescription')) + "\n                              ")]), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.payloadNiotixState')) + "\n                                  "), _c('pre', {
    staticClass: "example-block"
  }, [_vm._v("{\n  \"meta\": {\n    \"timestamp\": \"2022-07-08T07:25:27.447Z\",\n    \"state_id\": 55292,\n    \"dtwin_id\": 3613,\n    \"dtwin_title\": \"Example Virtual Device Name\",\n    \"twin_tags\": [\"tag1\",\"tag2\",\"tag3\"],\n    \"twin_category\": \"virtualDevice\",\n    \"vdevice_groups\": [\"group1\",\"group2\"],\n    \"twin_ancestor_ids\": [1544],\n    \"twin_key_value\": {},\n    \"geolocation\": {\"latitude\": 0, \"longitude\": 0, \"address\": \"123 Street\"},\n    \"unit\": \"kWh\",\n    \"state_identifier\": \"kWh\",\n    \"state_type\": \"number\",\n    \"account_id\": 482,\n    \"config_id\": 202,\n    \"source_type\": \"bridge\",\n    \"parser_variable\": \"kWh\",\n    \"source_identifier\": \"847D50161912202E\"\n  },\n  \"value\": 42\n}\n                                  ")])]), _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.jsonataTransformation')) + "\n                                  "), _c('pre', {
    staticClass: "example-block"
  }, [_vm._v("{\n  \"timestamp\": $.meta.timestamp,\n  \"value\": $.value\n}\n                                  ")])]), _c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$i18n_t('Connectors.Transformer.quickReference.exampleOutput')) + "\n                                  "), _c('pre', {
    staticClass: "example-block"
  }, [_vm._v("{\n  \"timestamp\": \"2022-07-08T07:25:27.447Z\",\n  \"value\": 42\n}\n                                  ")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };